module.exports = __webpack_public_path__ + "img/avatar-s-19.81a06756.jpg";